import Component from '../abstracts/Component';

export default class AnimateListingComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-listing-animate="true"]',
      items: '.l-p-c__prd-item',
    };
  }

  constructor() {
    super();
  }
  togglerAnimation(entries){
    const animatedClass = 'animated';
    for(let entry of entries){
      if(entry.isIntersecting){
        entry.target.classList.add(animatedClass);
      }
    }
  }
  observeItems(listing){
    let items = listing.querySelectorAll(this.SELECTORS.items);
    const observer = new IntersectionObserver(this.togglerAnimation,{threshold:.3});
    for (let item of items){
      observer.observe(item);
    }
  }
  initAll(datactx){
    const ctx = datactx ? datactx : this;
    let listingContainers = document.querySelectorAll(ctx.SELECTORS.main);
    for (let listing of listingContainers){
      ctx.observeItems(listing);
    }
  }
  initAllListener(e){
    const ctx = e.event.data.ctx;
    ctx.initAll(ctx);
  }
  render() {
    this.log("Rendering...")
    this.initAll();
    this.$on(this.$customEvents.INFINITE_SCROLL_EVENTS.animation,this.initAllListener,null,null,{ctx:this});
  }
}
